import * as changeTrackingDocument from "./changeTrackingDocument";
import get from "lodash.get";
import flow from "lodash.flow";
import curry from "lodash.curry";

const traverse = curry((propertyPath, ruleObj, ctDocument) => {
  const result = Object.entries(ruleObj || {}).reduce((accumulator, [prop, fnOrObj]) => {
    const childPropertyPath = combinePath(propertyPath, prop);
    const match = typeof fnOrObj === "function" ? applyRule : traverse;
    const result = match(childPropertyPath, fnOrObj, accumulator);
    return result;
  }, ctDocument);
  return result;
});

function applyRule(propertyPath, ruleFn, ctDocument) {
  const newValue = ruleFn(ctDocument.document, ctDocument.originalDocument, get(ctDocument.document, propertyPath));
  return changeTrackingDocument.updateProperty(propertyPath, newValue, ctDocument);
}

function combinePath(left, right) {
  const combined = left ? `${left}.${right}` : right;
  return combined;
}

export function update(document, rules, changes = {}) {
  return flow(changeTrackingDocument.create, changeTrackingDocument.update(changes), traverse(null, rules))(document);
}
